import React from 'react';

const VideosIcon = () => (
  <svg width="24" height="24" viewBox="0 0 48 48" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 8C10.4477 8 10 8.44772 10 9V21C10 21.5523 10.4477 22 11 22H13C13.5523 22 14 21.5523 14 21V9C14 8.44772 13.5523 8 13 8H11ZM11 26C10.4477 26 10 26.4477 10 27V39C10 39.5523 10.4477 40 11 40H13C13.5523 40 14 39.5523 14 39V27C14 26.4477 13.5523 26 13 26H11ZM22 9C22 8.44772 22.4477 8 23 8H25C25.5523 8 26 8.44772 26 9V21C26 21.5523 25.5523 22 25 22H23C22.4477 22 22 21.5523 22 21V9ZM23 26C22.4477 26 22 26.4477 22 27V39C22 39.5523 22.4477 40 23 40H25C25.5523 40 26 39.5523 26 39V27C26 26.4477 25.5523 26 25 26H23ZM34 9C34 8.44772 34.4477 8 35 8H37C37.5523 8 38 8.44772 38 9V21C38 21.5523 37.5523 22 37 22H35C34.4477 22 34 21.5523 34 21V9ZM35 26C34.4477 26 34 26.4477 34 27V39C34 39.5523 34.4477 40 35 40H37C37.5523 40 38 39.5523 38 39V27C38 26.4477 37.5523 26 37 26H35Z"
    />
  </svg>
);

export default VideosIcon;
